export default __webpack_public_path__ + "static/SSSpyView_screenshot-3@mob2x-65cf0345c111a60810fd6dc88b5cb2d9.webp";